<template>
  <v-card
    :width="width"
    height="240"
    style="
      margin-right: 10px;
      margin-bottom: 10px;
      border: 1px dashed #292961;
      border-radius: 10px;
      background-color: rgb(234, 238, 255);
    "
    elevation="0"
  >
    <v-card-text
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      "
    >
      <v-card-text
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          flex-direction: column;
        "
      >
        <slot />
      </v-card-text>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    props: ["width"]
}
</script>